import { render, staticRenderFns } from "./Template2.vue?vue&type=template&id=b0539242&scoped=true"
import script from "./Template2.vue?vue&type=script&lang=js"
export * from "./Template2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0539242",
  null
  
)

export default component.exports